import {useMutation} from "@tanstack/react-query";
import {updateGroup} from "../services/GroupService";

export function useGroupUpdate() {
    return useMutation({
        mutationFn: ({id, payload}) => updateGroup(id, payload),
    });
}
